import { isC3Experience } from "../../../shared/util/C3Utils";

define((require) => {
    "use strict";

    var $                   = require("jquery"),
        Configuration       = require("shared/services/Configuration"),
        CompanyState        = require("shared/data/CompanyState"),
        ConfirmationManager = require("services/ConfirmationManager"),
        EditorEvents        = require("shared/services/EditorEvents"),
        ImprovedView        = require("editor/zbone/ImprovedView"),
        LoggedInUserState   = require("shared/ui/user/LoggedInUserState"),
        template            = require("ui/common/NavBarCurrentPrincipalView.tpl"),
        {Logger}            = require("shared/util/Logger"),
        Permissions         = require("shared/security/Permissions"),
        Tooltip             = require("ui/common/Tooltip"),
        tooltipTemplate     = require("ui/common/NavBarCurrentPrincipalViewTooltip.tpl"),
        LoggedIn            = require("shared/security/LoggedIn"),
        MD5                 = require("md5");
        Storage             = require("shared/services/Storage");


    const log = new Logger("CurrentPrincipal");
    const zsitesHTML = "Manage Microsites";
    const experienceExportHTML = "Experience Export";

    /**
     * The nav bar subview for the options relating to the current principal.
     *
     * @class NavBarCurrentPrincipalView
     * @constructor
     *
     * @cfg {Principal} The principal to display the view for.
     */
    return ImprovedView.extend({

        className: "nav-bar-current-principal-view",

        template: template,

        zsitesHTML: "Manage Microsites",

        experienceExportHTML: "Experience Export",

        templateHelpers: function() {
            // On AD login, the principal role is the AD role, but the user may still be coerced into Spectator on
            // inactive company. This is only to display the roles visually, nothing to do with the actual permission checks...
            const user = this.model.get("user");
            const type = this.model.get("type");
            const integrations = LoggedInUserState.get("integrations");
            const settings = LoggedInUserState.get("companySettings");
            const userRole = (type === "AD" && (this.model.get("state") !== CompanyState.ACTIVE || !user.isConfirmed())) ? Permissions.Roles.SPECTATOR : user.get("role");

            return {
                principalName:           this.model.get("displayName"),             // principal display name
                principalRole:           this.model.get("role").name,               // principal role, i.e. active role!
                type:                    type,                                      // AD, ReadOnly, or Normal
                userName:                user.get("displayName"),                   // user display name
                userRole:                userRole.name,                             // (coerced) user role
                unconfirmed:             !user.isConfirmed(),                       // true for unconfirmed user
                fontsIntegrationEnabled: integrations.fontIntegrationsEnabled(),
                zsitesEnabled:           integrations.isZSitesEnabled(),
                zsitesHTML:              zsitesHTML,
                experienceExportHTML:    experienceExportHTML,
                experienceExportEnabled: settings.get("exportingExperiencesEnabled") &&
                (userRole === Permissions.Roles.SITEMANAGER || type === "LDAP"),
                designFileUIEnabled:     settings.get("designFileUIEnabled"),
                newDashboardExperience: isC3Experience()
            };
        },

        ui: {
            helpLink:           ".help-link",
            guidedTourNavIcon:  ".guided-tour-nav-icon",
            resendConfirmation: ".resend-confirmation",
            username:           ".mini-profile .name",
            navigationLinks:    ".nav-dropdown a",
            zsitesLink:       ".icon-microsites"
        },

        events: {
            "click @ui.helpLink": function() {
                var eventProperties = {
                    projectId: this.options.project && this.options.project.get("id"),
                    triggerOrigin: "HelpLinkButton"
                };

                EditorEvents.trigger(EditorEvents.constants.OPEN_HELP_LINK, eventProperties);
            },

            "click @ui.resendConfirmation": function(event) {
                event.preventDefault();
                ConfirmationManager.requestConfirmationInfo(true);
            },

            "click @ui.navigationLinks": function(event) {
                if (!event.currentTarget.innerHTML.includes(zsitesHTML)) {
                    this.trigger("navigation", event);
                }
            },

            "click @ui.zsitesLink": "_postZSites"
        },

        _postZSites: function() {
            // We rename this clientId because it's clientId in the matomo code and it makes debugging md5 hashes easier
            const clientId =  LoggedIn.principal().get("companyId");
            const email = LoggedIn.principal().get("user.username");
            const clientName = LoggedIn.principal().get("user.name");
            const secret = Configuration.zsitesSecret;
            const zsites = "zsites";
            const list = "list";
            var settings = LoggedInUserState.get("companySettings");
            const zsiteVanityUrlsEnabled = settings.get("zsiteVanityUrlsEnabled");
            const zsiteVanityUrlMaxCount = settings.get("zsiteVanityUrlMaxCount");
            const zsiteNonVanityUrlMaxCount = settings.get("zsiteNonVanityUrlMaxCount");

            var experienceId = "";
            if (this.options.experienceId) {
                experienceId = this.options.experienceId;
            }
            $.post(
                Configuration.zsitesConfig, {
                    mode: zsites,
                    action: list,
                    companyId: clientId,
                    email: email,
                    clientName: clientName,
                    experienceId: experienceId,
                    key: MD5(zsites + list + clientId + clientName + email + experienceId + secret),
                    a: zsiteVanityUrlsEnabled,
                    b: zsiteVanityUrlMaxCount,
                    c: zsiteNonVanityUrlMaxCount
                },
                (data) => {
                    window.open(data, "_blank");
                }
            );
        },

        onRender: function() {
            this.ui.guidedTourNavIcon.css("display", "inline-block");

            this.stickit(LoggedInUserState, this.supportLinkBinding);

            // Show company info tooltip on AD/internal login so we can easily get company id, name, etc.
            var principal = this.model;

            if (principal.get("type") === "AD" || principal.get("internal")) {
                var company      = LoggedInUserState.get("company"),
                    settings     = LoggedInUserState.get("companySettings"),
                    integrations = LoggedInUserState.get("integrations"),
                    user         = LoggedInUserState.get("user"),
                    flip         = false;

                Tooltip.add(this.ui.username, {
                    html: true,
                    content: function() {
                        // This is because the tooltip plugin calls the function twice: to determine if it has any
                        // content, then to get the content... :/
                        flip = !flip;

                        if (flip) {
                            log.info("Principal:", principal.toString(), "->", user.toString(), principal);
                            log.info("Company:  ", company.toString(), company);
                            log.info("Settings: ", settings.toString(), settings);
                        }

                        return tooltipTemplate({
                            company: company.toJSON(),
                            settings: settings.toJSON(),
                            userId: user.get("id"),
                            fontIntegrationsEnabled: integrations.fontIntegrationsEnabled(),
                            zsitesEnabled: integrations.isZSitesEnabled()
                        });
                    },

                    placement: "left",
                    duration: 0,
                    delay: {show: 1000, hide: 0}
                });
            }
        },

        onClose: function() {
            if (this.model.get("type") === "AD") {
                Tooltip.remove(this.ui.username);
            }
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/common/NavBarCurrentPrincipalView.js